export default "__VITE_ASSET__BHw0fz$0__"